import React from 'react';
import { 
    MarginContainerStyled, 
    // MarginTextStyled 
} from '../styles/Margin';

function Footer() {
    return (
        <MarginContainerStyled className='margin-container'>
            {/* <MarginTextStyled>Made with ❤️ by Big Al</MarginTextStyled> */}
        </MarginContainerStyled>
    );
}

export default Footer;